/**
 * Lot Visibility & Pagination
 *
 * Manages visible lots and pagination logic
 * @module portal/modules/lotOperations/visibility
 */

import { state } from '../state';
import { Lot } from '../types';
import { sortLots } from './sorting';
import { applyLotFilters } from './filtering';

/**
 * Compute visible lots based on filters, sorting, and pagination
 */
export function computeVisibleLots(): Lot[] {
  if (!Array.isArray(state.lots)) return [];

  // Apply filters
  const filtered = applyLotFilters(state.lots);

  // Sort
  const sorted = sortLots(filtered);

  // Paginate
  const start = (state.page - 1) * state.pageSize;
  const end = start + state.pageSize;
  return sorted.slice(start, end);
}

/**
 * Get pagination information
 */
export function getPaginationInfo(): {
  total: number;
  page: number;
  pages: number;
  hasPrev: boolean;
  hasNext: boolean;
} {
  const filtered = applyLotFilters(state.lots);
  const total = filtered.length;
  const pages = Math.ceil(total / state.pageSize) || 1;

  return {
    total,
    page: state.page,
    pages,
    hasPrev: state.page > 1,
    hasNext: state.page < pages,
  };
}
